import React, { useContext, useState } from "react";
import styled from "styled-components";
import { FormContext } from "../context/FormContext";
import ModalC2cGeneric from './ModalC2cGeneric';
import LogoWom from "../images/logowom.svg";
import Transbank from "../images/transbank.svg";
import IconFacebook from "../images/icon_facebook.svg";
import IconTwitter from "../images/icon_twitter.svg";
import IconYoutube from "../images/icon_youtube.svg";
import IconInstagram from "../images/icon_instagram.svg";
import IconPhoneOne from "../images/ico_phone_one.svg";
import IconPhoneTwo from "../images/ico_phone_two.svg";
import IconWhatsapp from "../images/ico_whatsapp.svg";

const FooterWom = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #2d1441;
  padding: 0 15px;
  position: relative;
  z-index: 99;
  ul {
    &.w-190{
      width: 190px;
    }
    li {
      font-size: 13px;
      line-height: 16px;
      color: #afa6b7;
      margin-bottom: 10px;
      list-style: none;
      &:last-child {
        margin-bottom: 0;
      }
      span {
        font-weight: bold;
        font-size: 16px;
        line-height: 20px;
        color: #ffffff;
        padding-bottom: 5px;
        display: block;
      }
      &.social-links {
        width: 100%;
        max-width: 190px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        a {
          transition: transform 0.3s;
          &:hover {
            transform: scale(1.2);
          }
        }
      }
      &.li-inline {
        display: flex;
        flex-direction: row;
        /* justify-content: flex-start; */
        align-items: center;
        picture {
          width: 23px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 5px;
        }
        span {
          padding: 0;
        }
      }
    }
  }
  .d-center{
    display: block;
    margin: 0 auto;
    img{
      margin: 0 auto 40px;
      display: block;
    }
  }
  .text-center{
    text-align: center;
  }
`;

const WrapperFooter = styled.div`
  width: 100%;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  ul {
    display: flex;
    flex-direction: column;
    li {
      display: flex;
      justify-content: center;
      align-self: center;
      text-align: center;
    }
    .bolder {
      font-weight: bold;
    }
    .li-inline {
      width: 200px;
      height: 40px;
      margin: 9px 0 16px !important;
      border: 1px solid #9a89a4;
      box-sizing: border-box;
      border-radius: 20px;
    }
    .social-links {
      width: 100%;
    }
  }
  .content-footer {
    width: 100%;
    max-width: 240px;
    margin-bottom: 40px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .logo-footer {
    display: blocK;
    margin: 0 auto;
  }
`;
const ContentBajadaInfo = styled.article`
  padding: 0 15px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: auto;
  margin-left: auto;
  margin-right: auto;
  transform: translateY(-350px);
  margin-bottom: 25px;
  @media (max-width: 480px) {
    transform: translateY(-290px);
    margin: 0;
  }
`;
const BajadaTitle = styled.h3`
  font-size: 16px;
  line-height: 20px;
  color: #381451;
  margin: 0 0 10px;
  text-align: center;
`;
const BajadaInfo = styled.h3`
  font-size: 13px;
  line-height: 17px;
  color: #381451;
  text-align: center;
  .contact-tel{
    color:#381451;
  }
  span{
    font-weight:bold;
    text-decoration:underline;
    cursor: pointer;
  }
`;
const Footer = ({isOpenC2c, setIsOpenC2c}) => {
  const { formData, setFormData } = useContext(FormContext);
  const [ openModalC2c, setOpenModalC2c ] = useState(false);
  return (
    <FooterWom>
      <WrapperFooter>
        {/*
          (
            formData.selectedPlan === "50gigas-gratis" ||
            formData.selectedPlan === "200gb-50dcto" ||
            formData.selectedPlan === "300gb-50dcto" ||
            formData.selectedPlan === "400gb-50dcto" ||
            formData.selectedPlan === "500gb-50dcto" ||
            formData.selectedPlan === "libre-50dcto"
          ) &&
          (
            <ContentBajadaInfo>
              <BajadaTitle>¿Necesitas ayuda?</BajadaTitle>
              <BajadaInfo>Si quieres que uno de nuestros ejecutivos te ayude a contratar este plan <span onClick={() => setOpenModalC2c(!openModalC2c)}>haz click aquí</span></BajadaInfo>
            </ContentBajadaInfo>
          )
        */}
        {
          (
            formData.selectedPlan === undefined ||
            formData.selectedPlan === "PlanWOM250GB-WOM62" ||
            formData.selectedPlan === "PlanMas250GB" ||
            formData.selectedPlan === "PlanMas250GB-WOM71" ||
            formData.selectedPlan === "PlanMas400GB-WOM72" ||
            formData.selectedPlan === "PlanWOMGBLibre" ||
            formData.selectedPlan === "PlanMasLibre" ||
            formData.selectedPlan === "PlanMasGBLibre" ||
            formData.selectedPlan === "PlanMasGBLibrePlus" ||
            formData.selectedPlan === "PlanAcumula200Gigas" ||
            formData.selectedPlan === "PlanAcumula300GB" ||
            formData.selectedPlan === "PlanWOM400GB-WOM64" ||
            formData.selectedPlan === "PlanAcumula400GB" ||
            formData.selectedPlan === "PlanMas400GB" ||
            formData.selectedPlan === "PlanWOM250GB" ||
            formData.selectedPlan === "PlanWOM400GB" ||
            formData.selectedPlan === "PlanWOMLibre" ||
            formData.selectedPlan === "PlanMas250Gigas" ||
            formData.selectedPlan === "PlanMas400Gigas" ||
            formData.selectedPlan === "PlanMasGigasLibres" ||
            formData.selectedPlan === "PlanMasGigasLibresPlus" ||
            formData.selectedPlan === "WOMmas400Gigas" ||
            formData.selectedPlan === "WOMmas400GigasTactico" ||
            formData.selectedPlan === "WOMmas600Gigas" ||
            formData.selectedPlan === "WOMmasLibre" ||
            formData.selectedPlan === "WOMmasLibrePlus" ||
            formData.selectedPlan === "PlanWOM150Gigas" ||
            formData.selectedPlan === "OfertaWOM150gb" ||
            formData.selectedPlan === "OfertaWOMmas300gb" ||
            formData.selectedPlan === "OfertaWOMmas450gb" ||
            formData.selectedPlan === "OfertaWOMmasgblibres" ||
            formData.selectedPlan === "OfertaWOMmasgblibresplus" ||
            formData.selectedPlan === "WOM7950dcto" ||
            formData.selectedPlan === "PILOTO_PlanWOM150Gigas" ||
            formData.selectedPlan === "PlanWOM150Gigas-WOM86"  ||
            formData.selectedPlan === "PlanGBLibre" ||
            formData.selectedPlan === "PlanGBLibrePlus" ||
            formData.selectedPlan === "150gb-ref"
          )
          ?
          (
            <div className="content-footer">
              <div>
                <img className="logo-footer" src={LogoWom} alt="wom footer" />
              </div>
              <div>
                <ul>
                  <li className="bolder">Síguenos en:</li>
                  <li className="social-links">
                    <a
                      href="https://facebook.com/womchile"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={IconFacebook} alt="facebook" />
                    </a>
                    <a
                      href="https://twitter.com/womchile"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={IconTwitter} alt="twitter" />
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UCPM0XXrP4i724aYt27QLBxA"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={IconYoutube} alt="youtube" />
                    </a>
                    <a
                      href="https://instagram.com/womchile"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={IconInstagram} alt="instagram" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          )
          :
          (
            <div className="d-center">
              <img className="logo-footer" src={LogoWom} alt="wom footer" />
              <ul className="w-190">
                <li className="bolder text-center">Síguenos en:</li>
                <li className="social-links">
                  <a
                    href="https://facebook.com/womchile"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={IconFacebook} alt="facebook" />
                  </a>
                  <a
                    href="https://twitter.com/womchile"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={IconTwitter} alt="twitter" />
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCPM0XXrP4i724aYt27QLBxA"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={IconYoutube} alt="youtube" />
                  </a>
                  <a
                    href="https://instagram.com/womchile"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={IconInstagram} alt="instagram" />
                  </a>
                </li>
              </ul>
            </div>
          )
        }
      </WrapperFooter>
    </FooterWom>
  );
};

export default Footer;
